/** Sibling of the view-health and interaction beacons. */
export const ERROR_VOLUME_ENDPOINT = '/api/metrics/frontend/error-volume/';

/** Matches the other beacons; keeps a slow POST off any critical path. */
export const ERROR_VOLUME_BEACON_TIMEOUT_MS = 5_000;

/**
 * How often a non-empty window is flushed. Long enough that the beacon itself
 * stays negligible traffic, short enough that a tab closed mid-session loses at
 * most one window.
 */
export const ERROR_VOLUME_FLUSH_INTERVAL_MS = 60_000;

/**
 * Per-kind ceiling for one window, mirroring MAX_ERROR_VOLUME_COUNT in
 * apps/utils/views.py. A browser past this is in a runaway-error loop; counts
 * are clamped so one pathological tab cannot dominate the aggregate — and, more
 * practically, so the backend does not reject the whole flush for one bad kind.
 */
export const ERROR_VOLUME_MAX_COUNT = 10_000;

/**
 * Cap on distinct signatures tracked per window for the deduplicated figure.
 * Bounds memory on a page looping through many *different* errors; past the cap
 * the unique count stops rising, so treat it as a floor rather than a truth.
 */
export const ERROR_VOLUME_MAX_SIGNATURES = 500;

/** Longest signature fragment retained, to bound memory per entry. */
export const ERROR_VOLUME_SIGNATURE_MAX_LENGTH = 200;
